import type { ButtonHTMLAttributes } from 'react'

export type FuseGridBrandMarkVariant = 'spark' | 'grid' | 'workbook'

function cx(...parts: Array<string | null | undefined | false>) {
  return parts.filter(Boolean).join(' ')
}

export function FuseGridBrandMark({
  variant = 'spark',
  className,
}: {
  variant?: FuseGridBrandMarkVariant
  className?: string
}) {
  if (variant === 'grid') {
    return (
      <svg
        className={cx('fg-brand-mark', className)}
        viewBox="0 0 32 32"
        role="img"
        aria-label="FuseGrid"
      >
        <rect width="32" height="32" rx="7" fill="#107c41" />
        <rect x="7" y="7" width="18" height="18" rx="2.2" fill="#fff" />
        <path d="M7 13h18M7 19h18M13 7v18M19 7v18" stroke="#107c41" strokeWidth="1.9" />
        <rect x="7" y="7" width="6" height="6" rx="1.5" fill="#a7f3d0" />
      </svg>
    )
  }

  if (variant === 'workbook') {
    return (
      <svg
        className={cx('fg-brand-mark', className)}
        viewBox="0 0 32 32"
        role="img"
        aria-label="FuseGrid"
      >
        <rect width="32" height="32" rx="7" fill="#107c41" />
        <path d="M9 6.5h10l4 4v15H9z" fill="#fff" />
        <path d="M19 6.5v5h4" fill="#d9f7e6" />
        <path d="M12 15h8M12 19h8M12 23h5" stroke="#107c41" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    )
  }

  return (
    <svg
      className={cx('fg-brand-mark', className)}
      viewBox="0 0 32 32"
      role="img"
      aria-label="FuseGrid"
    >
      <rect width="32" height="32" rx="7" fill="#0f8a4b" />
      <path d="M7 21.5h18" stroke="#dff7ea" strokeWidth="2.2" strokeLinecap="round" />
      <path d="M8 20l5-5 4 3 6-8" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="23" cy="10" r="2.4" fill="#a7f3d0" />
    </svg>
  )
}

export function FuseGridBrandButton({
  variant = 'spark',
  label = 'FuseGrid',
  subtitle,
  showLabel = true,
  href,
  onClick,
  className,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: FuseGridBrandMarkVariant
  label?: string
  subtitle?: string
  showLabel?: boolean
  href?: string
}) {
  return (
    <button
      {...rest}
      type="button"
      className={cx('fg-brand-button', !showLabel && 'fg-brand-button-icon-only', className)}
      title={rest.title ?? (href ? `${label} home` : label)}
      aria-label={rest['aria-label'] ?? (href ? `${label} home` : label)}
      onClick={(event) => {
        onClick?.(event)
        if (event.defaultPrevented || !href) return
        try {
          window.location.assign(href)
        } catch {
          window.location.href = href
        }
      }}
    >
      <FuseGridBrandMark variant={variant} />
      {showLabel ? (
        <span className="fg-brand-button-text">
          <span className="fg-brand-button-label">{label}</span>
          {subtitle ? <span className="fg-brand-button-subtitle">{subtitle}</span> : null}
        </span>
      ) : null}
    </button>
  )
}
